var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.8333C34.8333 21.8333 34.5 22 34.3333 22.1667L32.6667 23.8333L36.1667 27.3333L37.8333 25.6667C38.1667 25.3333 38.1667 24.6667 37.8333 24.3333L35.6667 22.1667C35.5 22 35.3333 21.8333 35 21.8333ZM31.8333 24.8333L21.6667 34.8333V38.3333H25.1667L35.3333 28.1667L31.8333 24.8333ZM35 5H21.6667V15H35V5ZM31.6667 11.6667H25V8.33333H31.6667V11.6667ZM21.6667 30.1V18.3333H35V18.5C33.7333 18.5 32.6167 19.1667 31.9833 19.8167L30.1167 21.6667H25V26.7833L21.6667 30.1ZM18.3333 5H5V21.6667H18.3333V5ZM15 18.3333H8.33333V8.33333H15V18.3333ZM18.3333 33.4333V25H5V35H18.3333V33.4333ZM15 31.6667H8.33333V28.3333H15V31.6667Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.1f0f8382a952263511d988813e361de8.svg";
export { ForwardRef as ReactComponent };